<template>
  <div class="ui left aligned container">
    <div class="ui feed">
      <div class="event" v-for="message of messages" :key="message.id">
        <div class="content">
          <div class="summary">
            {{ message.title }}
            <div class="date">
              {{ message.createdTime | datetime }}
            </div>
          </div>
          <div class="extra text" v-html="message.content"></div>
          <div class="ui divider"></div>
        </div>
      </div>
    </div>

    <infinite-loading :identifier="infiniteId" @infinite="load">
      <div slot="spinner">加载中...</div>
      <div slot="no-results">没有消息</div>
      <span slot="no-more"></span>
    </infinite-loading>

  </div>
</template>

<script>
import axios from 'axios'
import EventBus from '@/services/event-bus'
import InfiniteLoading from 'vue-infinite-loading'

export default {
  name: 'UserMessage',
  components: {
    InfiniteLoading,
  },
  data () {
    return {
      page: 0,
      infiniteId: +new Date(),
      loading: false,
      messages: []
    }
  },
  mounted () {
    EventBus.$emit('message')
  },
  methods: {
    load ($state) {
      this.loading = true
      axios.get('/messages?sort=id,desc&page=' + this.page).then(({ data }) => {
        this.loading = false
        if (data.content.length) {
          this.page += 1
          this.messages.push(...data.content)
          $state && $state.loaded()
        } else {
          $state && $state.complete()
        }
      }, () => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
.container {
  margin-top: 24px;
}
</style>
